import Blue from '~/core';

new Blue({
  name: 'Alert',
  selector: '.alert:not(.alert--is-static)',
  setup(alert) {
    const id = `alert--${alert.getAttribute('id')}--dismissed`;
    const dismiss = alert.querySelector('.alert__close');
    const shouldDismiss = JSON.parse(localStorage.getItem(id) || 'false');
    const drawer = document.querySelector('header .header__drawer');

    if (shouldDismiss) doDismiss(true);
    else alert.classList.add('visible');

    this.$addEvents(dismiss, 'click.stop.prevent enter.stop.prevent', () =>
      doDismiss()
    );

    function doDismiss(immediate = false) {
      localStorage.setItem(id, JSON.stringify(true));
      if (immediate) return alert.remove();
      let animation = alert.animate(
        [{ height: `${alert.offsetHeight}px` }, { height: `0px` }],
        {
          duration: 200,
          easing: 'ease',
          fill: 'forwards',
        }
      );
      const drawerOffset = parseInt(drawer.style.top) - alert.offsetHeight;
      const drawerAnimation = drawer.animate(
        [
          {
            height: drawer.style.height,
            top: drawer.style.top,
          },
          {
            height: `calc(100% - ${drawerOffset}px)`,
            top: `${drawerOffset}px`,
          },
        ],
        {
          duration: 200,
          easing: 'ease',
        }
      );
      animation.onfinish = () => {
        alert.remove();
      };
      drawerAnimation.onfinish = () => {
        drawer.style.top = `${drawerOffset}px`;
        drawer.style.height = `calc(100% - ${drawerOffset}px)`;
      };
    }
  },
});
